import styled from '@emotion/styled'

export const Wrapper = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1em;
`

export const Backdrop = styled.div`
  position: fixed;
  z-index: 300;
  inset: 0;
  background: rgba(0,0,0,.3);
`

export const StyledModal = styled.div`
  background: ${props => props.theme.background};
  box-sizing: border-box;
  padding: 3em 3.5em;
  z-index: 500;
  position: relative;
`

export const CloseButton = styled.button`
  position: absolute;
  top: .5em;
  right: .5em;
  margin: 0;
  padding: .5em;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font: inherit;
  color: inherit;
`